<template>
  <div style="height: 100%;width: 100%;border-radius: 10px">

  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import { mapGetters } from 'vuex'
  export default {
    name: 'BarChart',
    props: {
      data: {
        type: Array
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        chart: null
      }
    },
    watch: {
      data(val, oldVal) {
        const _this = this
        if(this.chart !== null) {
          this.chart.update({
            series: [{
              data: [
                {
                  x: 0,
                  y: _this.data[0],
                  name: '当天',
                  color: "#F28894"
                }, {
                  x: 1,
                  y: _this.data[1],
                  name: '7天内',
                  color: "#6AD7CB"
                }, {
                  x: 2,
                  y: _this.data[2],
                  name: '30天内',
                  color: '#9BDBF8'
                }
              ]
            }]
          })
        }
      },
      sidebar: {
        deep: true,
        handler() {
          this.chart.update({
            chart: {
              width: this.width,
              height: this.height
            },
          })
          console.log(this.width)
        }
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      width() {
        return this.$el.clientWidth
      },
      height() {
        return this.$el.clientHeight
      }
    },
    mounted() {
      const _this = this
      const chart = Highcharts.chart(this.$el, {
        chart: {
          type: 'bar',
          width: _this.width,
          height: _this.height
        },
        title: {
          align: 'left',
          text: _this.title,
          style: {
            'fontWeight': 'bold'
          }
        },
        xAxis: {
          title: {
            text: null
          },

          categories: ['当日', '7天内', '30天内']
        },
        yAxis: {
          title: {
            text: null
          },
          gridLineColor: 'transparent',
          min: 0,
          minRange: 4
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '{point.name} : {point.y}'
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          data: [
            {
              x: 0,
              y: _this.data[0],
              name: '当天',
              color: "#F28894"
            }, {
              x: 1,
              y: _this.data[1],
              name: '7天内',
              color: "#6AD7CB"
            }, {
              x: 2,
              y: _this.data[2],
              name: '30天内',
              color: '#9BDBF8'
            }
          ]
        }]
      });
      this.chart = chart
    }
  }
</script>

<style>

</style>